import { useLocation } from 'react-router';
import ContainerWithGoBack from './ContainerWithGoBack';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    divContent: {
        flex: 1,
        marginTop: '20px',
        marginBottom: '20px',

    },
    divImageFullScreen: {
        width: '45%',
        resizeMode: 'contain',
    },

});

const ImageUriFullScreen = () => {
    const location = useLocation();
    const classes = useStyles();
    const uri = location.state.uri;

    return (
        <ContainerWithGoBack>
            <div className={classes.divContent}>
                <img
                    className={classes.divImageFullScreen}
                    alt=""
                    src={uri}
                />
            </div>
        </ContainerWithGoBack>
    );
}

export default ImageUriFullScreen;